import { render } from "./KeyPeriod.vue?vue&type=template&id=0a2bc852"
import script from "./KeyPeriod.vue?vue&type=script&lang=ts"
export * from "./KeyPeriod.vue?vue&type=script&lang=ts"
script.render = render

export default script